import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardBody, CardText, Input } from "reactstrap";

const PricingPlanModal = ({ isOpen, toggle, plans, selectedPlan, setSelectedPlan, onConfirm, warning, isConfirmLoading = false, loader = false }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Choose a Pricing Plan</ModalHeader>
      <ModalBody>
        {loader ? (
          <div className="d-flex flex-column" style={{ gap: 12 }}>
            {[1, 2, 3].map(item => (
              <div
                key={item}
                className="subscription-skeleton-line"
                style={{ height: 56, borderRadius: 8 }}
              />
            ))}
          </div>
        ) : (
          <div className="d-flex flex-wrap gap-3" style={{ maxHeight: '350px', overflowY: 'auto' }}>
            {plans?.length ? plans.map((plan, idx) => (
              <Card
                key={plan.publisher_subscription_id || plan.subscription_type_id || idx}
                className={`plan-card ${selectedPlan?.publisher_subscription_id === plan.publisher_subscription_id ? "selected" : ""}`}
                style={{ minWidth: 220,width:'100%', cursor: "pointer", border: selectedPlan?.publisher_subscription_id === plan.publisher_subscription_id ? "2px solid #007bff" : "1px solid #ccc" }}
                onClick={() => {
                  if (!isConfirmLoading) {
                    setSelectedPlan(plan)
                  }
                }}
              >
                <CardBody>
                  <div className="d-flex align-items-center p-2">
                    <Input
                      style={{ position: "relative", width: 'auto', margin: 0, left: 0 }}
                      type="radio"
                      name="plan"
                      checked={selectedPlan?.publisher_subscription_id === plan.publisher_subscription_id}
                      onChange={() => setSelectedPlan(plan)}
                      disabled={isConfirmLoading}
                    />
                    <CardText className="ms-2 mb-0">
                      {plan.label}
                    </CardText>
                  </div>
                </CardBody>
              </Card>
            )) : (
              <div className="w-100 text-center text-muted py-2">No plans available</div>
            )}
          </div>
        )}
      </ModalBody>
       {warning && (
          <div className="w-80 m-2" style={{ color: '#856404', background: '#fff3cd', border: '1px solid #ffeeba', borderRadius: 4, padding: '8px 12px', fontSize: 13 }}>
            {warning}
          </div>
        )}
      <ModalFooter>
        <Button color="primary" onClick={onConfirm} disabled={!selectedPlan || isConfirmLoading || loader}>{isConfirmLoading ? 'Processing...' : 'Confirm'}</Button>
        <Button color="secondary" onClick={toggle} disabled={isConfirmLoading}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default PricingPlanModal;
